"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleSelectionSubtextInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var Input_1 = require("../../Input");
// iOS で max-height を指定しないと、補助テキストのテキストボックスの下線が見えなくなるので指定
var SUBTEXT_ITEM_MAX_HEIGHT = 41;
var SubtextInputField = react_1.default.forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var propertyId = _a.propertyId, disabled = _a.disabled, displayError = _a.displayError, subtextString = _a.subtextString, item = _a.item, onSubtextBlur = _a.onSubtextBlur, onSubtextChange = _a.onSubtextChange;
    var handleSubtextChange = function (e) {
        onSubtextChange(item.value)(e.target.value);
    };
    var handleSubtextBlur = function (e) {
        onSubtextBlur(item.value)(e.target.value);
    };
    return ((0, jsx_runtime_1.jsx)(Input_1.Input, { ref: ref, type: "text", name: "".concat(propertyId, "-").concat((_b = item.value) !== null && _b !== void 0 ? _b : 'unselected', "-subtext"), "aria-label": item.label, "data-cy-property-item": "subtext", placeholder: (_d = (_c = item.subtext) === null || _c === void 0 ? void 0 : _c.placeholder) !== null && _d !== void 0 ? _d : '', disabled: disabled, error: displayError, maxHeight: SUBTEXT_ITEM_MAX_HEIGHT, "aria-invalid": displayError, value: subtextString !== null && subtextString !== void 0 ? subtextString : '', onChange: handleSubtextChange, onBlur: handleSubtextBlur }));
});
var StyledMultipleSelectionSubtextItemWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  opacity: ", ";\n  transition:\n    height 0.2s ease-out,\n    opacity 0.2s ease-out;\n  &[aria-hidden='true'] {\n    visibility: hidden;\n  }\n  &[aria-hidden='false'] {\n    visibility: visible;\n  }\n\n  label: SubtextWrapper;\n"], ["\n  height: ", ";\n  opacity: ", ";\n  transition:\n    height 0.2s ease-out,\n    opacity 0.2s ease-out;\n  &[aria-hidden='true'] {\n    visibility: hidden;\n  }\n  &[aria-hidden='false'] {\n    visibility: visible;\n  }\n\n  label: SubtextWrapper;\n"])), function (_a) {
    var checked = _a.checked, height = _a.height;
    return (checked ? "".concat(height, "px") : 0);
}, function (_a) {
    var checked = _a.checked;
    return (checked ? 1 : 0);
});
var INPUT_HEIGHT_BASE = 40;
var MultipleSelectionSubtextInput = function (_a) {
    var checked = _a.checked, props = __rest(_a, ["checked"]);
    var inputRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(INPUT_HEIGHT_BASE), height = _b[0], setHeight = _b[1];
    (0, react_1.useEffect)(function () {
        if (inputRef.current) {
            setHeight(inputRef.current.offsetHeight);
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(StyledMultipleSelectionSubtextItemWrapper, __assign({ height: height, checked: checked, "aria-hidden": !checked }, { children: (0, jsx_runtime_1.jsx)(SubtextInputField, __assign({}, props, { ref: inputRef })) })));
};
exports.MultipleSelectionSubtextInput = MultipleSelectionSubtextInput;
var templateObject_1;
